import { noop } from "lodash-es";

import { asyncNoop } from "@/utils/async/utils";
import { objectId } from "@/utils/objectId";

import type { BackendWriteSession } from "./BackendWriteSession";

const asyncAny = <T>() => Promise.resolve({} as T);

export function backendWriteSessionDummy(): BackendWriteSession {
  return {
    syncBacklog: asyncAny,
    syncIteration: asyncAny,
    sessionPublish: noop,
    boardPublish: noop,
    boardCall: asyncAny,
    addBoard: () => Promise.resolve(""),
    updateBoard: asyncNoop,
    deleteBoard: asyncNoop,
    duplicateFlex: asyncNoop,
    newSticky: () => Promise.resolve(""),
    mirror: asyncAny,
    move: noop,
    toRisk: noop,
    addLink: asyncAny,
    addObjectiveLink: asyncNoop,
    deleteLink: asyncNoop,
    deleteObjectiveLink: asyncNoop,
    addCategory: () => Promise.resolve(""),
    deleteCategory: asyncNoop,
    updateCategory: asyncNoop,
    addBoardToCategory: asyncNoop,
    removeBoardFromCategory: asyncNoop,
    createTimerEvent: () => Promise.resolve(""),
    updateTimerEvent: asyncNoop,
    deleteEvent: asyncNoop,
    addReaction: asyncNoop,
    removeReaction: asyncNoop,
    addShape: () => Promise.resolve(objectId()),
    editShape: asyncNoop,
    removeShape: asyncNoop,
    createConfidenceVoteSession: asyncAny,
    getConfidenceVoteSessions: asyncAny,
    endConfidenceVoteSession: asyncAny,
    joinConfidenceVoteSession: asyncAny,
    getConfidenceVoteSessionParticipants: asyncAny,
    getMyVote: asyncAny,
    addVote: asyncAny,
    deleteConfidenceVoteSession: asyncNoop,
    updateConfidenceVoteSession: asyncAny,
    startConfidenceVoteSession: asyncAny,
    deleteCard: asyncAny,
    getAlmKanbanConfigs: asyncAny,
    listOnboardingPresets: () => Promise.resolve([]),
    createOnboardingSession: () => Promise.resolve({ sessionId: "", artId: 0, teamIds: [] }),
  };
}
